var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongArrowRight35 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 70,
  height: 35,
  viewBox: "0 0 70 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.8536 13.1464C64.6583 12.9512 64.3417 12.9512 64.1464 13.1464C63.9512 13.3417 63.9512 13.6583 64.1464 13.8536L67.2929 17H1.5C1.22386 17 1 17.2239 1 17.5C1 17.7761 1.22386 18 1.5 18H67.2929L64.1464 21.1464C63.9512 21.3417 63.9512 21.6583 64.1464 21.8536C64.3417 22.0488 64.6583 22.0488 64.8536 21.8536L68.8536 17.8536C69.0488 17.6583 69.0488 17.3417 68.8536 17.1464L64.8536 13.1464Z",
  fill: "currentColor"
})));
export default SvgLongArrowRight35;